import { render, staticRenderFns } from "./VChartBar.vue?vue&type=template&id=4f35e1c8&scoped=true&"
import script from "./VChartBar.vue?vue&type=script&lang=ts&"
export * from "./VChartBar.vue?vue&type=script&lang=ts&"
import style0 from "./VChartBar.vue?vue&type=style&index=0&id=4f35e1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f35e1c8",
  null
  
)

export default component.exports